module.exports = function() {
  return new Worker(__webpack_public_path__ + "a199dcf91983d0319378.worker.js");
};